<template>
    <div class="reward-box">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <img v-if="received != 1" class="box-img dimmed" :src="boxImg" alt="" />
            <img v-else class="box-img" :src="boxImg2" alt="" />
            <div class="overlay-text">
                <div :style="{
                    color: received == 1 ? '#e670c8' : '#86718c',
                     fontWeight: received == 1 ? '600' : '100'
                }">
                    {{ peopleCount }} {{ $t('common.pepole') }}
                </div>

                <div class="rewardNum" :style="{
                    padding: '5px 0',
                    color: received == 1 ? 'gold' : '#ffffffa6',
                    fontSize: '13px',
                    fontWeight: received == 1 ? '600' : '100'
                }">
                    {{ Number(reward) }}
                </div>
            </div>
            <img v-if="down && !isLast" class="arrow-img-down" :src="require('@/assets/bauDo/next.png')"
                style="transform: rotate(90deg) " alt="arrow" />
        </div>

        <img v-if="((!down && !isInCorner) || (isInCorner && side == 'right' && down) || (isInCorner && side == 'left' && !down))" class="arrow-img" :src="require('@/assets/bauDo/next.png')"
            :style="{ visibility: ((!down && !isInCorner) || (isInCorner && side == 'right' && down) || (isInCorner && side == 'left' && !down)) ? 'visible' : 'hidden', transform: side == 'right' ? 'rotate(180deg)' : '' }"
            alt="arrow" />
    </div>

</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: 'RewardBox',
    props: {
        peopleCount: {
            type: Number,
            required: true,
        },
        reward: {
            type: String,
            required: true,
        },
        arrow: {
            type: String,
            required: false,
        },
        down: {
            type: Boolean,
            required: false,
            default: false,
        },
        side: {
            type: String,
            required: false,
        },
        isInCorner: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false,
        },
        boxImg: {
            type: String,
            default: () => require('@/assets/bauDo/treasureChest.png'),
        },
        boxImg2: {
            type: String,
            default: () => require('@/assets/bauDo/treasureChest.png'),
        },
        received: {
            type: Number,
            default: () => 0,
            required: true,
        }
    },
})
</script>

<style scoped>
.reward-box {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.box-img {
    width: 50px;
    /* height: 49px; */
}

.dimmed {
    filter: brightness(50%);
}

.completeBox {
    width: 17vw;
    /* height: 49px; */
    background: green;
}

.arrow-img {
    width: 25px;
    height: 25px;
    margin-top: 5px;
    margin-left: 10px;
}

.arrow-img-down {
    display: flex;
    justify-content: center;
    width: 25px;
    height: 25px;
    /* margin-top: 27px; */
    /* margin-left: 15px; */
}

.overlay-text {
    /* position: absolute;
    top: 53px;
    height: 49px;
    width: 90%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-size: 10px;
    color: white;
}

@media (min-width: 400px) {
    .box-img {
        /* width: 68px !important; */
    }
}

@media (min-width: 1440px) {
    .arrow-img-down {
        /* margin-right: 30px; */
        width: 35px;
        height: 35px;
    }

    .arrow-img {
        margin-left: 1vw;
        width: 35px;
        height: 35px;
    }

    .box-img {
        /* width: 68px; */
    }

}

@media (min-width: 1920px) {
    .arrow-img-down {
        /* margin-right: 50px; */
    }

    .arrow-img {
        margin-left: 1vw;
        height: 1vw;
        width: 1vw;
    }

    .arrow-img-down {
        height: 1vw;
        width: 1vw;
    }

}
</style>